/*
 * @Description:
 * @LastEditors: Please set LastEditors
 * @Date: 2020-12-30 15:01:16
 */

import { isContainRevokePeople } from '@/api/ajax';
import Vue from 'vue';
import {
  individualEnterpriseName,
  individualName
} from '@/page/settlementCenter/common/tableConfig/fields.js';
import { individualEnterpriseName as individualEnterpriseNameForSearch } from '@/page/settlementCenter/common/tableConfig/search.js';
// { name: '待支付', key: 0 },
// { name: '支付中', key: 1 },
// { name: '部分支付成功', key: 2 },
// // { name: '支付成功', key: 3 },
// { name: '支付失败', key: 4 }
// const payStatusMap = {
//   0: '待支付',
//   1: '支付中',
//   2: '部分支付成功',
//   3: '支付成功',
//   4: '支付失败'
// };
/**
 * @description: 获取对应类型的支付状态文字
 * @param {number} type 当前订单类型 1组合 2 3 4
 * @return {string}
 */
const getPayStatusTextMap = (type = 0) => {
  return type <= 1
    ? ['待支付', '支付中', '部分支付成功', '支付成功', '支付失败']
    : ['待支付', '支付中', '支付成功', '支付失败'];
};
export const array2String = (arr, field = 'id') =>
  arr.map(item => (field ? item[field] : item)).join(',');

export const string2Array = value => (value + '').split(',');

/**
 * @description: 获取所勾选的集合并通过priceType过滤后整合csoCustomOrderIds
 * @param {array} arr 所勾选的集合
 * @return {string} csoCustomOrderIds
 */
export const selection2StringForCsoCustomOrderIds = arr => {
  const csoCustomOrderIds = [];
  arr
    .filter(item => item.priceType === 1)
    .forEach(item => {
      const ids = item.csoCustomOrderIds || item.id; // 不一定所有接口的字段都改了，有的还是用了id
      [].push.apply(csoCustomOrderIds, string2Array(ids));
    });
  return csoCustomOrderIds.join(',');
};

/**
 * @description: 根据priceType字段对应field生成数据
 * @param {array} orders 所选数据
 * @param {string} field 取值字段 如果是csoCustomOrderIds则需要分割数据
 * @return {object} {csoCustomOrderIds:'1,2,3,4',csoOrderServicesIds:2,....}
 */
export const formatOrdersFieldByType = (
  orders,
  field = 'csoCustomOrderIds'
) => {
  const result = {};
  const mapping = {
    1: { key: 'csoCustomOrderIds', value: [] },
    2: { key: 'csoOrderServicesIds', value: [] },
    3: { key: 'authOrderIds', value: [] },
    4: { key: 'comprehensiveOrderIds', value: [] },
    6: { key: 'csoBusServicesIds', value: [] }
  };
  if (orders) {
    orders.forEach(item => {
      if (mapping[item.priceType]) {
        if (item.priceType === 1) {
          const id = (item[field] || item.id) + ''; // 为了兼容后端一会csoCustomOrderIds一会用id
          [].push.apply(
            mapping[item.priceType].value,
            field === 'csoCustomOrderIds' ? string2Array(id) : [id]
          );
        } else {
          // 其他类型优先使用id
          mapping[item.priceType].value.push((item.id || item[field]) + '');
        }
      }
    });
    Object.values(mapping).forEach(({ key, value }) => {
      value = value.join(',');
      result[key] = value;
    });
  }
  return result;
};
export function addQuery(ajax, query) {
  return function(data) {
    data = Object.assign({}, query, data);
    return ajax.call(null, data);
  };
}
// 用于判断当前选中数据是否可下一步
export const isRevokePeople = async (selection, needJoin = true) => {
  try {
    // 只传递项目费用类型的ids
    let { data } = await isContainRevokePeople({
      csoOrderIds: needJoin
        ? selection2StringForCsoCustomOrderIds(selection)
        : typeof selection === 'object'
        ? selection.map(i => i.id).join(',')
        : selection
    });
    return Promise.resolve(data);
  } catch (e) {
    return Promise.reject(e);
  }
};

/**
 * @description: 用于支付状态显示
 * @param {object} row
 * @param {number} cursorPriceType 自定义订单类型
 * @return {string}
 */
export const payStatusRender = (row, cursorPriceType) => {
  if (Object.prototype.toString.call(row) !== '[object Object]') {
    throw new Error('payStatusRender need Object');
  }

  // 关闭支付、线下支付完成，特殊处理标识
  const { closeOrRgStatus, closeOrRgType } = row;
  if (+closeOrRgStatus === 2) {
    if (+closeOrRgType === 1) return '关闭支付';
    if (+closeOrRgType === 2) return '线下支付完成';
  }

  // 退出结算特殊处理
  const { payStatus, revokeStatus, priceType } = row;
  if (+revokeStatus === 2) return '退出结算';

  // 结算中都使用0-3的类型
  let _priceType = cursorPriceType ? cursorPriceType : priceType;
  return getPayStatusTextMap(_priceType)[payStatus] || '-';
};

/**
 * @description: 支付超额人员列表,需要调用指向
 * @param {object} query orderTips组件需要参数
 * @param {function} getListAjax 组件内使用接口
 * @param {object} component 显示组件
 * @return {void}
 */
export const useQuotaDialog = async function(
  query,
  getListAjax,
  component = require('@/page/settlementCenter/components/orderTips').default,
  cancelText = '返回修改'
) {
  this.$xrkDialog({
    title: '提示',
    width: '80vw',
    showConfirm: false,
    cancelText,
    cancelType: 'primary',
    $slots: {
      default: this.$createElement(component, {
        props: {
          query,
          getListAjax
        }
      })
    }
  });
};
export const imitateAjax = list => {
  return () => {
    return new Promise(resolve => {
      resolve({ data: { data: { list } } });
    });
  };
};
/**
 * @description: 替换个体搜索与列表字段
 * @param {object} currentSearch tableRender中search对象
 *                 currentFields tableRender中field对象
 *                 userEnterpriseType 用户类型 3个体 1自然人
 * @return {voide}
 */
export const editOperatorCommonFields = ({
  currentSearch,
  currentFields,
  userEnterpriseType
}) => {
  if (userEnterpriseType != 3) return;
  // 园区个体字段修改
  currentSearch.forEach(item => {
    // 园区个体写死
    if (item.label === '交易结构') {
      item.val = '5';
      item.disabled = true;
    }
  });
  // 无供应商
  currentSearch.splice(
    currentSearch.findIndex(item => item.label === '供应商'),
    1
  );
  const individualNameIndexForSplit =
    currentSearch.findIndex(item => item.label === '项目参与人') + 1;
  // 添加个体名称搜索
  if (individualNameIndexForSplit) {
    currentSearch.splice(
      individualNameIndexForSplit,
      0,
      individualEnterpriseNameForSearch
    );
  }

  // splice里的循环必须重载，否则arr不同步
  currentFields.splice(
    currentFields.findIndex(item => item.label === '项目参与人'),
    1,
    individualEnterpriseName,
    individualName
  );
  currentFields.splice(
    currentFields.findIndex(item => item.label === '供应商'),
    1
  );
  currentFields.splice(
    currentFields.findIndex(item => item.label === '服务费率'),
    1
  );
};
export const proxyData = data => {
  return new Vue({ data });
};
